module.exports = __webpack_public_path__ + "img/nav1.809dcc4f.png";